<template>
  <footer class="main-footer">
    <div v-if="!nocard" class="trand-card">
      <div class="item user">
        <a
          class="name-card"
          :href="data.nameCard"
          data-stat-id="name"
          :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
        >
          <img
            class="head"
            :src="`${data.photo}?x-oss-process=image/resize,m_mfit,h_80,w_80`"
            :alt="data.name"
          >
          <div
            class="info"
            :class="{ member: data.memberLevelName || data.offlineBroker }"
          >
            <p class="name">
              <span>{{ data.name }}</span>
              <i
                v-if="data.memberLevelMedal && !data.offlineBroker"
                class="icon-member"
              >
                <img :src="data.memberLevelMedal" :alt="data.memberLevelName">
              </i>
            </p>
            <p v-if="data.offlineBroker">{{ isBxs ? '保险师' : '' }}专员</p>
            <p v-else-if="data.memberLevelName">{{ data.memberLevelName }}</p>
          </div>
        </a>
      </div>

      <div class="item phone" :class="{ line: !bApp }">
        <a
          :href="'tel:' + data.telephone"
          data-stat-id="phone"
          :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
        >
          <template v-if="bApp">{{ data.telephone }}</template>
          <template
            v-else
          ><i class="iconfont icon-phone_line" /><span>联系我</span></template>
        </a>
      </div>

      <!-- :class="{'tr': mini}" -->
      <div v-if="bApp" class="item edit">
        <a
          :href="data.nameCard"
          data-stat-id="edit"
          :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
        >
          <span class="inner">编辑名片</span>
        </a>
      </div>
      <div v-else class="item see">
        <a
          :href="data.nameCard"
          data-stat-id="name"
          :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
        ><i class="iconfont icon-business_card" /><span>查看名片</span></a>
      </div>

      <!-- <div class="item minipg"
        v-if="mini">
        <a href="javascript:;"
          @click="clickHandler">
          <span class="inner after-bdr">分享计划书</span>
        </a>
      </div> -->
    </div>
    <div v-if="bApp || isTrades" class="trand-insure">
      <div class="fix-bottom">
        <template v-if="bApp">
          <a
            class="btn"
            href="javascript:;"
            @click="handleClick('generate')"
          >生成PDF/WORD/图片</a>
          <a
            class="btn"
            data-stat-id="share_bottom"
            @click="handleClick('share')"
          >转发计划书</a>
        </template>
        <template v-else>
          <template v-if="isTrades">
            <a
              v-if="bApp"
              key="ljtb"
              class="btn"
              :href="
                data.trades[0].productInfo &&
                  data.trades[0].productInfo.tradeUrl
              "
              data-stat-id="lktb"
              :data-stat-ep="
                JSON.stringify({ cpId: data.trades[0].productInfo.tradeId })
              "
            >立即投保</a>
            <a
              v-else
              key="ljtb"
              class="btn"
              :href="
                data.trades[0].productInfo &&
                  data.trades[0].productInfo.shareTradeUrl
              "
              data-stat-id="lktb"
              :data-stat-ep="
                JSON.stringify({ cpId: data.trades[0].productInfo.tradeId })
              "
            >立即投保</a>
          </template>
          <template v-else />
        </template>
      </div>
    </div>
  </footer>
</template>

<script>
import { bApp, isBxs } from 'base/config'
import { getUrlParam, getUrlByAddingParam } from 'common/js/common'

const EVENT_CLICK = 'click'

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    inMiniGroup: {
      type: Boolean,
      default: false,
    },
    isTrades: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    this.isBxs = isBxs
    return {
      bApp: bApp,
      telephone: '',
      nocard: false, //&nocard=1
    }
  },
  computed: {
    mini() {
      const { inMiniGroup } = this
      const suptShareMini =
        window.appBridge &&
        appBridge.checkAppFeature('GOTO_WECHAT_MINI_PROGRAM')

      return bApp && inMiniGroup && suptShareMini
    },
  },
  created() {
    const nocard = getUrlParam('nocard')
    nocard == 1 && (this.nocard = true)
    const uuid = getUrlParam('uuid')
    const theme = getUrlParam('theme')
    const sourceFrom = JSON.stringify({ uuid, theme })
    this.data.nameCard = getUrlByAddingParam(
      {
        sourceFrom,
      },
      this.data.nameCard
    )
  },
  methods: {
    handleClick(type) {
      this.$emit(type)
    },
  },
}
</script>

<style lang="postcss" scoped>
@import 'variable.css';

.main-footer {
  overflow: hidden;
  position: relative;
  width: 94.667%;
  margin: 0 auto 10px;
  font-size: 13px;
  border-radius: 4px;
  background-color: #fff;
  text-align: center;
  .item {
    float: left;
    position: relative;
    background-color: #fff;
    a {
      display: block;
      height: 100%;
      line-height: 60px;
      color: var(--primary-color-text);
    }
  }
  .after-bd-r:after {
    height: 40%;
    bottom: 30%;
    background-color: rgba(51, 51, 51, 0.4);
  }
  .user {
    width: 38.7%;
  }
  .phone,
  .minipg {
    width: 33%;
  }
  .see,
  .edit {
    width: 28.3%;
  }
  .name-card {
    .info {
      padding-left: 44.1%;
      font-size: 15px;
      text-align: left;
      p {
        font-size: 16px;
        font-weight: 400;
        @apply --text-ellipsis;
      }
    }
    .head {
      position: absolute;
      left: 10%;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      border-radius: 100%;
    }
  }
  .icon-member {
    z-index: 1;
    position: absolute;
    display: inline-block;
    overflow: hidden;
    width: 15px;
    height: 15px;
    margin-left: 3px;
    img {
      width: 100%;
    }
  }
  .member {
    padding-top: 13px;
    line-height: 1.2;
    > p {
      @apply --text-ellipsis;
    }
    .name {
      padding-right: 21px;
      span {
        display: inline-block;
        max-width: 100%;
        @apply --text-ellipsis;
      }
    }
    p:last-child {
      margin-top: 3px;
      font-size: 12px;
      color: #999;
      transform: scale(0.83);
      transform-origin: left top;
    }
  }
  .phone,
  .see {
    .iconfont {
      margin-right: 6px;
      font-size: 18px;
      line-height: 1;
      vertical-align: middle;
    }
    span {
      font-size: 14px;
      vertical-align: middle;
      line-height: 1;
    }
  }
  .line {
    &:before,
    &:after {
      @apply --bd-w;
      background-color: var(--primary-color-border);
      height: 58%;
      top: 21%;
    }
    &:before {
      left: 6%;
    }
    &:after {
      right: 6%;
    }
  }
  .edit {
    span {
      display: inline-block;
      padding: 9px 12px;
      font-size: 13px;
      line-height: 1.3;
      border-radius: 2px;
    }
  }
  .tr {
    text-align: right;
  }
  .minipg {
    span {
      display: inline-block;
      padding: 9px 12px;
      font-size: 13px;
      line-height: 1.3;
      border-radius: 2px;
      background-color: #fff;
    }
  }
}

.trand-card {
  width: 100%;
  display: flex;
}
.fix-bottom {
  display: flex;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.trand-insure {
  z-index: 100;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 7px 0;
  box-sizing: content-box;
  font-size: 15px;
  text-align: center;
  .btn {
    display: block;
    flex: 1;
    /* width: 94.67%; */
    margin: 0 5px;
    line-height: 36px;
    border-radius: 4px;
    color: white;
  }
}

@media screen and (device-width <= 320px) {
  .main-footer {
    .name-card {
      .head {
        left: 4%;
      }
      .info {
        p {
          font-size: 13px;
        }
      }
    }
    .phone,
    .see,
    .minipg {
      span {
        font-size: 12px;
      }
    }
    .icon-member {
      margin-left: 0;
    }
    .minipg {
      span {
        line-height: 1.4;
      }
    }
  }
}
</style>
